(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  (() => {
    const revealItems = () => {
      const items = document.querySelectorAll('.product-grid__item:not(.is-visible)');
      if (!items.length) return;

      const observer = new IntersectionObserver(
        (entries, obs) => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            obs.unobserve(entry.target);
          });
        },
        { threshold: 0.15 }
      );

      items.forEach(item => observer.observe(item));
    };

    document.addEventListener('DOMContentLoaded', revealItems);
    document.addEventListener('shopify:section:load', revealItems);
  })();
  document.addEventListener('shopify:section:load', () => {
  document
    .querySelectorAll('.product-grid__item')
    .forEach(item => item.classList.add('is-visible'));
});

document.addEventListener('collection:reloaded', () => {
  document
    .querySelectorAll('.product-grid__item')
    .forEach(item => item.classList.add('is-visible'));
});

  } catch(e) { console.error(e); }
})();
})();
